import { TreeNode } from 'primeng/api';

export class DimensionTreeInfo {
    titlei18n: string = '';
    helptexti18n: string = '';
    nonConformed: boolean = false;
    treeNode: TreeNode[] = [];

    constructor(singleFact: boolean, nonConformed: boolean, treeNode: TreeNode[]) {
        if (singleFact) {
            this.titlei18n = 'cs.bia.analysis.one.table';
            this.helptexti18n = 'cs.bia.analysis.one.table.info';
        } else {
            if (nonConformed) {
                this.titlei18n = 'cs.bia.analysis.non.conformed';
                this.helptexti18n = 'cs.bia.analysis.non.conformed.info';
            } else {
                this.titlei18n = 'cs.bia.analysis.conformed';
                this.helptexti18n = 'cs.bia.analysis.conformed.info';
            }
        }
        this.nonConformed = nonConformed;
        this.treeNode = treeNode;
    }

    refresh() {
        this.treeNode = [...this.treeNode];
    }
}
